import Icon from '../../shared/components/Icons';
import { SmartImg } from '../../shared/components/Layout';
import { fmtDay } from '../../shared/data/common';

/** Activity summary used on review, confirmation and booking details pages. */
export default function SightseeingSummary({ summary: s }) {
  return (
    <div className="sum">
      <div className="sum-media">
        <div className="sum-thumb"><SmartImg src={s.image} alt={s.title} /></div>
        <div>
          <span className="tag">{s.optionName}</span>
          <h3>{s.title}</h3>
          <span className="muted small"><Icon name="pin" size={13} /> {s.city} · <Icon name="clock" size={13} /> {s.duration}</span>
        </div>
      </div>
      <div className="kv-grid">
        <div><span className="muted small">Date</span><b>{fmtDay(s.date)}</b></div>
        <div><span className="muted small">Time slot</span><b>{s.slot}</b></div>
        <div><span className="muted small">Participants</span><b>{s.adults} Adult{s.adults > 1 ? 's' : ''}{s.children ? `, ${s.children} Child${s.children > 1 ? 'ren' : ''}` : ''}</b></div>
      </div>
      <div className="sum-foot">
        <span><Icon name="pin" size={14} /> Meeting point: {s.meeting}</span>
        <span className="text-primary"><Icon name="zap" size={14} /> Mobile voucher · Instant confirmation</span>
      </div>
    </div>
  );
}
